<template>
  <a-modal v-model="visible" :title="`柜格管理：【${cabinet.code}】（${cabinet.location}）`" width="800px">
    <a-table
        :columns="columns"
        :data-source="recordList"
        :pagination="false"
        rowKey="id"
        :scroll="{ y: 500 }"
        v-if="recordList.length > 0">
      <span slot="status" slot-scope="text, record">
        <span v-if="!record.enable">
          <a-tag color="red">不可用</a-tag>
        </span>
        <span v-else>
          <span v-if="text === 'used'">
            <a-tag color="blue">占用中</a-tag>
          </span>
          <span v-if="text === 'available'">
            <a-tag color="green">可用</a-tag>
          </span>
        </span>
      </span>
    </a-table>
    <p v-else>无记录</p>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import cabinetService from '@/service/cabinet'

export default {
  data() {
    return {
      visible: false,
      recordList: [],
      bizOrgName: '',
      columns: [
        { title: "编号", dataIndex: 'code', align: 'center',},
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '最近投入时间', dataIndex: 'recentPutTime', align: 'center' },
      ],
      cabinet: {}
    };
  },
  methods: {
    showModal(cabinet) {
      this.visible = true;
      this.cabinet = cabinet;
      cabinetService.queryCellListById({id: cabinet.id}).then((res) => {
        this.recordList = res.data
      })
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
